export default {
    time(minutes) {
        if (!minutes || minutes <= 0) return "-";
        return minutes >= 60 ? `${Math.floor(minutes / 60)}h${String(minutes % 60).padStart(2, "0")}` : `${minutes}min`;
    },
    kW(watts) {
        return (watts / 1000).toFixed(1);
    },
    battery(percentStart, percent) {
        if (!percent) return "-";
        return percentStart ? `${Math.round(percentStart)}% → ${Math.round(percent)}%` : `${Math.round(percent)}%`;
    },
    // Encurta o e-mail para não ocupar a coluna, o completo fica no title
    shortEmail(email) {
        if (!email) return "";
        return email.length > 5 ? `${email.substr(0, 5)}…` : email;
    },
    nowUrl(charger, plug) {
        return `${window.location.origin}/now/${charger.name}/${plug}`;
    },
    // "dd/mm/aaaa hh:mm:ss" (formato da API) para "aaaammddhhmmss", que pode ser comparado como texto
    sortableDateTime(dateTime) {
        if (!dateTime) return null;
        return dateTime.substr(6, 4) + dateTime.substr(3, 2) + dateTime.substr(0, 2) + dateTime.substr(11, 2) + dateTime.substr(14, 2) + dateTime.substr(17, 2);
    },
};
